import {observer} from "mobx-react"
import React, {Component} from "react"
import PropTypes from "prop-types"
import {Table} from "semantic-ui-react"
import Price from "components/Price/Price"
import _ from "lodash"

@observer
export default class ProductTableReadOnly extends Component {
	static propTypes = {
		list    : PropTypes.object,
		cart    : PropTypes.object,
		onChange: PropTypes.func,
		products: PropTypes.array,
		minimal : PropTypes.bool
	}

	constructor() {
		super()
	}

	render() {
		let {list, cart, products, onChange, minimal, showTax} = this.props
		let positions = list || products
		if ( list ) positions = list.products
		let rows = _.map( positions, ( product, index ) => {
			return (
				<ProductRow showTax={showTax} minimal={minimal} key={index} index={index} onChange={onChange} list={list} cart={cart} product={product} />
			)
		} )
		return (
			<Table>
				<colgroup>
					<col width="40%" />
					<col width="" />
					<col width="5%" />
				</colgroup>
				<thead>
				<tr>
					<th>Artikel</th>
					{/*{!minimal && <th>{translate("Preis/VE")}</th>}*/}
					{/*<th>{translate( "VE" )}</th>*/}
					<th>{translate( "Menge" )}</th>
					{showTax && <th>{translate( "Steuer" )}</th>}
					<th className="tr">
						<div className="tr">{translate( "Summe" )}</div>
					</th>
				</tr>
				</thead>
				<tbody>
				{rows}
				</tbody>
			</Table>
		)
	}
}

const ProductRow = ( {product, minimal, showTax} ) => {
	return (
		<tr>
			<td>
				<strong>{product.article_nr}</strong>
				<div><span className="product-title"><span className="nowrap">{product.title}</span></span></div>
			</td>
			{/*{!minimal && <td><Price>{product.price}</Price></td>}*/}
			<td>
				<div className={"nowrap"}>{product.unit_multi} {translate( "Stück" )}</div>
			</td>
			{/*<td>*/}
			{/*	<div className={"nowrap"}>{product.count} {translate( "VE" )}</div>*/}
			{/*</td>*/}
		
			<td className="tr">
				<div className="tr"><Price>{product.price * product.count * product.unit_multi}</Price></div>
			</td>
		</tr>
	)
}

ProductRow.propTypes = {
	index   : PropTypes.any,
	list    : PropTypes.object,
	cart    : PropTypes.object,
	onChange: PropTypes.func,
	product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/braunco/components/Product/ProductTableReadOnly.js